<template>
  <div>
    <form
      id="new_customer"
      class="simple_form second-account-form"
      novalidate="novalidate"
      action="/customers/sign_in"
      accept-charset="UTF-8"
      data-remote="true"
      method="post"
    >
      <input
        name="utf8"
        type="hidden"
        value="✓"
      >
      <div class="form-group">
        <input
          id="customer_email"
          type="hidden"
          :value="email"
          name="customer[email]"
        >
        <input
          id="customer_password"
          autocomplete="off"
          :placeholder="$t('form.password')"
          class="form-control password"
          type="password"
          name="customer[password]"
          @keyup.enter="submit"
        >
        <div class="response" />
      </div>
      <div class="form-group submit">
        <input
          id="loginBtn"
          type="submit"
          name="commit"
          :value="$t('logIn')"
          class="btn btn-secondary btn-block login-btn"
          data-disable-with="Log In"
        >
      </div>
    </form>
    <div class="text-center">
      <a href="/customers/password/new">{{ $t('forgotYourPassword') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['email'],
  methods: {
    submit() {
      const passwordInput = document.getElementById('customer_password')
      const login = document.getElementById('loginBtn')
      passwordInput.addEventListener('keyup', function(e) {
        if (e.keyCode === 13) { login.click() }
      })
    },
  }
}
</script>